import styled from "styled-components";

export const Container = styled.div`
  @media (min-width: 1921px) {
    border-bottom: 2px solid #575757;
    padding: 28px 0px 28px 18px;
    display: flex;
    flex-direction: row;
    gap: 24px;
    cursor: pointer;
    height: 133px;
    align-items: center;

    .title {
      width: 18%;
      display: flex;
      flex-direction: column;
      font-weight: 800;
      font-size: 26px;
      line-height: 100%;
      letter-spacing: -0.05em;
      color: #653cd5;
      text-align: center;

      .date {
        font-weight: 700;
        font-size: 16px;
      }
    }

    .line {
      width: 0.5px;
      height: 77px;
      background-color: #000000;
    }

    .newsletter {
      width: 82%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 5px;

      .artInside {
        font-weight: 700;
        font-size: 20px;
        line-height: 100%;
        letter-spacing: -0.05em;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        word-break: break-word;
      }
      .titles {
        font-weight: 800;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: -0.05em;
        .main {
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          word-break: break-word;
          overflow-wrap: anywhere;
        }
        .sub {
          font-weight: 400;
          font-size: 18px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          color: #5f5f5f;
        }
      }
      .more-btn {
        min-width: 28px;
        height: 28px;
        background: #393939;
        box-shadow: 0px 1px 7px 0px #0000002e;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        justify-self: center;
        cursor: pointer;
      }
    }
  }

  @media (min-width: 1351px) and (max-width: 1920px) {
    border-bottom: 2px solid #575757;
    padding: 24px 0px 24px 18px;
    display: flex;
    flex-direction: row;
    gap: 26px;
    cursor: pointer;
    height: 125px;
    align-items: center;

    .title {
      width: 18%;
      display: flex;
      flex-direction: column;
      font-weight: 800;
      font-size: 24px;
      line-height: 100%;
      letter-spacing: -0.05em;
      color: #653cd5;
      text-align: center;

      .date {
        font-weight: 700;
        font-size: 16px;
      }
    }

    .line {
      width: 0.5px;
      height: 77px;
      background-color: #000000;
    }

    .newsletter {
      width: 82%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 8px;

      .artInside {
        font-weight: 700;
        font-size: 20px;
        line-height: 100%;
        letter-spacing: -0.05em;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        word-break: break-word;
      }

      .titles {
        font-weight: 800;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: -0.05em;
        .main {
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          word-break: break-word;
          overflow-wrap: anywhere;
        }
        .sub {
          font-weight: 400;
          font-size: 16px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          color: #5f5f5f;
        }
      }
      .more-btn {
        min-width: 26px;
        height: 26px;
        background: #393939;
        box-shadow: 0px 1px 7px 0px #0000002e;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        justify-self: center;
        cursor: pointer;
      }
    }
  }

  @media (min-width: 1025px) and (max-width: 1350px) {
    border-bottom: 2px solid #575757;
    padding: 16px 0px 16px 14px;
    display: flex;
    flex-direction: row;
    gap: 26px;
    cursor: pointer;
    height: 102px;
    align-items: center;

    .title {
      width: 14%;
      display: flex;
      flex-direction: column;
      font-weight: 800;
      font-size: 20px;
      line-height: 100%;
      letter-spacing: -0.05em;
      color: #653cd5;
      text-align: center;

      .date {
        font-weight: 700;
        font-size: 14px;
      }
    }

    .line {
      width: 0.5px;
      height: 70px;
      background-color: #000000;
    }

    .newsletter {
      width: 86%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 8px;

      .artInside {
        font-weight: 700;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: -0.05em;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        word-break: break-word;
      }

      .titles {
        font-weight: 800;
        font-size: 16px;
        line-height: 22px;
        letter-spacing: -0.05em;
        .main {
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          word-break: break-word;
          overflow-wrap: anywhere;
        }
        .sub {
          font-weight: 400;
          font-size: 14px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          color: #5f5f5f;
        }
      }
      .more-btn {
        min-width: 22px;
        height: 22px;
        background: #393939;
        box-shadow: 0px 1px 7px 0px #0000002e;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        justify-self: center;
        cursor: pointer;
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    border-bottom: 2px solid #575757;
    padding: 13px 0px 13px 14px;
    display: flex;
    flex-direction: row;
    gap: 16px;
    cursor: pointer;
    height: 98px;
    align-items: center;

    .title {
      width: 20%;
      display: flex;
      flex-direction: column;
      font-weight: 800;
      font-size: 16px;
      line-height: 100%;
      letter-spacing: -0.05em;
      color: #653cd5;
      text-align: center;

      .date {
        font-weight: 700;
        font-size: 12px;
      }
    }

    .line {
      width: 1px;
      height: 72px;
      background-color: #bbbbbb;
    }

    .newsletter {
      width: 80%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 4px;

      .artInside {
        font-weight: 700;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: -0.05em;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        word-break: break-word;
      }

      .titles {
        font-weight: 800;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: -0.05em;
        .main {
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          word-break: break-word;
          overflow-wrap: anywhere;
        }
        .sub {
          font-weight: 400;
          font-size: 12px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          color: #5f5f5f;
        }
      }
      .more-btn {
        width: 20px;
        height: 20px;
        background: #393939;
        box-shadow: 0px 1px 7px 0px #0000002e;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        justify-self: center;
        cursor: pointer;
      }
    }
  }

  @media (min-width: 568px) and (max-width: 767px) {
    border-bottom: 2px solid #575757;
    padding: 31px 0px 31px 14px;
    display: flex;
    flex-direction: row;
    gap: 13px;
    cursor: pointer;
    align-items: center;

    .title {
      width: 17%;
      display: flex;
      flex-direction: column;
      font-weight: 800;
      font-size: 24px;
      line-height: 100%;
      letter-spacing: -0.05em;
      color: #653cd5;
      text-align: center;

      .date {
        font-weight: 700;
        font-size: 16px;
      }
    }

    .line {
      width: 1px;
      height: 112px;
      background-color: #bbbbbb;
    }

    .newsletter {
      width: 83%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 4px;

      .artInside {
        font-weight: 700;
        font-size: 24px;
        line-height: 34px;
        letter-spacing: -0.05em;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        word-break: break-word;
        overflow-wrap: anywhere;
      }

      .titles {
        font-weight: 800;
        font-size: 22px;
        line-height: 30px;
        letter-spacing: -0.05em;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        word-break: break-word;
        overflow-wrap: anywhere;
        .main {
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
        }
        .sub {
          font-weight: 400;
          font-size: 18px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          color: #5f5f5f;
        }
      }
      .more-btn {
        width: 24px;
        height: 24px;
        background: #393939;
        box-shadow: 0px 1px 7px 0px #0000002e;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        justify-self: center;
        cursor: pointer;
      }
    }
  }

  @media (max-width: 567px) {
    border-bottom: 2px solid #575757;
    padding: 15px 0px 15px 10px;
    display: flex;
    flex-direction: row;
    gap: 12px;
    cursor: pointer;
    align-items: center;

    .title {
      width: 20%;
      display: flex;
      flex-direction: column;
      font-weight: 800;
      font-size: 18px;
      line-height: 100%;
      letter-spacing: -0.05em;
      color: #653cd5;
      text-align: center;

      .date {
        font-weight: 700;
        font-size: 14px;
      }
    }

    .line {
      width: 1px;
      height: 112px;
      background-color: #bbbbbb;
    }

    .newsletter {
      width: 80%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 4px;

      .artInside {
        font-weight: 700;
        font-size: 16px;
        line-height: 22px;
        letter-spacing: -0.05em;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        word-break: break-word;
        overflow-wrap: anywhere;
      }

      .titles {
        font-weight: 800;
        font-size: 16px;
        line-height: 22px;
        letter-spacing: -0.05em;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        word-break: break-word;
        overflow-wrap: anywhere;

        .main {
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3;
        }
        .sub {
          font-weight: 400;
          font-size: 14px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          color: #5f5f5f;
        }
      }
      .more-btn {
        width: 21px;
        height: 21px;
        background: #393939;
        box-shadow: 0px 1px 7px 0px #0000002e;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        justify-self: center;
        cursor: pointer;
      }
    }
  }
`;
